import {QUERY_KEYS} from '@/queryClient'
import {ExportsListParams} from '@/features/exports/types'

/** Normalised filter object used inside the list query key (stable across renders). */
export interface ExportsListKeyFilters {
    entity?: string
    status?: string
    format?: string
    dateFrom?: string
    dateTo?: string
    includeArchived?: boolean
    limit?: number
}

export const exportsListKeyFilters = (params: Omit<ExportsListParams, 'page'>): ExportsListKeyFilters => ({
    entity: params.entity,
    status: params.status,
    format: params.format,
    dateFrom: params.dateFrom,
    dateTo: params.dateTo,
    includeArchived: params.includeArchived ?? false,
    limit: params.limit ?? 20
})

/** Prefix matching every export list query (used by the socket patcher). */
export const EXPORTS_LIST_KEY_PREFIX = [QUERY_KEYS.EXPORTS, 'list'] as const

export const exportsListKey = (params: Omit<ExportsListParams, 'page'>) =>
    [...EXPORTS_LIST_KEY_PREFIX, exportsListKeyFilters(params)] as const

export const exportsDetailKey = (id: string) => [QUERY_KEYS.EXPORTS, 'detail', id] as const
